// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 2.5H9.48063L11.4806 5H23V21H11.2678C11.7356 20.1025 12 19.0821 12 18C12 14.4102 9.08985 11.5 5.5 11.5C3.75351 11.5 2.16789 12.1888 1 13.3096V2.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.9083 18.002L6.04998 13.0878L4.62771 14.4939L7.10728 17.002L-0.00195312 17.002V19.002L7.10728 19.002L4.62771 21.5101L6.04999 22.9162L10.9083 18.002Z"}}]};

const FolderImportFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-import-filled',
    ref,
    icon: element,
  },
));

FolderImportFilledIcon.displayName = 'FolderImportFilledIcon';

export default FolderImportFilledIcon;
